
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="py-20 bg-gradient-to-br from-white via-[#F0F9FF] to-[#E0F2FE]">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold text-center mb-6 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-[#0EA5E9] to-[#6366F1]">About Talento AI</h1>
          
          <div className="max-w-3xl mx-auto">
            <p className="text-lg text-gray-700 mb-6">
              Talento AI is revolutionizing the way companies approach talent acquisition and deployment. 
              We bridge the gap between human talent and AI automation, creating hybrid roles that maximize productivity 
              and innovation.
            </p>
            
            <p className="text-lg text-gray-700 mb-6">Founded in 2025, our mission is to help organizations navigate the evolving landscape of AI-augmented work while providing meaningful opportunities for professionals to enhance their capabilities with AI tools.</p>
            
            <h2 className="text-2xl font-bold mt-12 mb-4 text-[#0EA5E9]">Our Vision</h2>
            <p className="text-lg text-gray-700 mb-6">
              We envision a future where human talent and artificial intelligence work seamlessly together, 
              complementing each other's strengths to achieve unprecedented levels of productivity, creativity, 
              and job satisfaction.
            </p>
            
            <h2 className="text-2xl font-bold mt-12 mb-4 text-[#0EA5E9]">Our Approach</h2>
            <p className="text-lg text-gray-700 mb-6">
              Instead of replacing humans with AI, we create customized AI agents that handle repetitive tasks, 
              allowing human talent to focus on high-value, strategic work that requires creativity, emotional 
              intelligence, and complex decision-making.
            </p>
            
            <h2 className="text-2xl font-bold mt-12 mb-4 text-[#0EA5E9]">Leadership Team</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold mb-2">Nikki Chow</h3>
                <p className="text-gray-600 italic mb-3">COO & Co-founder</p>
                <p className="text-gray-700">Former Management executive with 15+ years of experience in AI, Crypto and talent management.</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold mb-2">Chow Hee Hou</h3>
                <p className="text-gray-600 italic mb-3">CTO & Co-founder</p>
                <p className="text-gray-700">
                  AI researcher and engineer with expertise in building intelligent systems.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default About;
